import React from "react"
import { MainCP } from "../../Components/atributos-gestion/MainCP"

const ViewAtributosGestion: React.FC = () => <MainCP/>

export default ViewAtributosGestion